// Utility to export data to CSV and trigger download in browser
// Usage: exportToCSV(data, filename)

export function exportToCSV(data, filename, firstColumn) {
  if (!data || !data.length) return;
  let cols = Object.keys(data[0]);
  if (firstColumn && cols.includes(firstColumn)) {
    cols = [firstColumn, ...cols.filter((column) => column !== firstColumn)];
  }
  const csvRows = [
    cols.join(","),
    ...data.map(row => cols.map(col => {
      const val = row[col] !== undefined && row[col] !== null ? row[col] : "";
      // Escape quotes and commas
      return `"${String(val).replace(/"/g, '""')}"`;
    }).join(","))
  ];
  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
